import { PostPreviewProps } from 'components/PostPreviewModal/Types'
import Styles from './PostPreviewModalV2.module.scss'
import { PreviewRenderer } from './components/PreviewRenderer/PreviewRenderer'
import { SelectChannels } from './screens/SelectChannels/SelectChannels'
import { PostActions } from './components/PostActions/PostActions'
import { PostScheduler } from './screens/PostScheduler/PostScheduler'
import { observer } from 'mobx-react-lite'
import { usePostPreviewStore } from './PostPreviewStoreProvider'
import { PostPreviewScreens } from './PostPreviewStore'
import { ActionResult } from './screens/ActionResult/ActionResult'
import { PostAction } from './hooks/usePostActionService'
import { providerFromChannelType } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { PostPreviewProviders } from './Providers'
import { usePostPreviewContext } from 'components/PostPreviewModal/PostPreviewContext'
import { PostStatusPropertyValue } from 'api/clients/PropertyClient'
import { ScheduledPostErrorType } from 'api/clients/ScheduledPostsClient'
import { Error } from 'components/ArticlePostPreview/PostPreviewBody/Error'
import { useErrorAction } from 'components/ArticlePostPreview/PostPreviewBody/hooks'
import { Spinner } from 'common/Spinner/Spinner'
import { YoutubeScreen } from './screens/YoutubeScreen/YoutubeScreen'

const PostPreviewModalContent = observer(({ pollPreviewContentStream = true, ...props }: PostPreviewProps) => {
  const store = usePostPreviewStore()
  const { scheduledPost, status } = usePostPreviewContext()
  const errorMessage = scheduledPost?.error_message
  const errorType = scheduledPost?.error_type
  const isMediaError = errorType === ScheduledPostErrorType.MediaFormatError
  const postingFailed = status === PostStatusPropertyValue.Failed
  const { errorAction } = useErrorAction({ integration: scheduledPost?.external_integration, errorType })

  return (
    <div className={Styles.body}>
      <div className={Styles.content}>
        <PreviewRenderer channel={props.channel} pollPreviewContentStream={pollPreviewContentStream} />
      </div>
      <div className={Styles.content}>
        {errorMessage && postingFailed && !isMediaError && (
          <Error errorMessages={[errorMessage]} action={errorAction()} />
        )}
        {store.screen === PostPreviewScreens.CHANNEL_SCREEN && (
          <div className={Styles.actions}>
            <SelectChannels />
            <PostActions />
          </div>
        )}
        {store.screen === PostPreviewScreens.AUTOPOST_CALENDAR_SCREEN && (
          <PostScheduler action={PostAction.AutoSchedule} />
        )}
        {store.screen === PostPreviewScreens.YOUTUBE_SCREEN && (
          <>
            {!scheduledPost ? (
              <Spinner />
            ) : (
              <YoutubeScreen
                fileId={props.fileId}
                channel={props.channel as DesignChannel}
                scheduledPost={scheduledPost}
                providerName="YouTube"
                provider={providerFromChannelType[props.channel] || ExternalIntegrationEnum.YouTube}
                brandKitId={store.selectedBrandKitId}
              />
            )}
          </>
        )}
        {store.screen === PostPreviewScreens.REMINDER_CALENDAR_SCREEN && <PostScheduler action={PostAction.Reminder} />}
        {store.screen === PostPreviewScreens.RESULT_SCREEN && <ActionResult />}
      </div>
    </div>
  )
})

const PostPreviewModalContentContainer = (props: PostPreviewProps) => {
  return (
    <PostPreviewProviders {...props}>
      <PostPreviewModalContent {...props} />
    </PostPreviewProviders>
  )
}

export { PostPreviewModalContentContainer as PostPreviewModalContent }
